module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Key-7cf4907a5046eaf9fb8794df5565edce.svg";